import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import {
  URL_SUPPORT,
  ROW_COUNT,
  ROW_COUNT_MAX,
  API_ADMIN_PRODUCTO,
  API_ADMIN_TIPO_PROCESO,
  API_ADMIN_PARAMETROS,
} from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { IAreaResponsable } from "../../../entities/IAreaResponsable";
import { IProducto } from "../../../entities/IProducto";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";
const columnHelperProducto = createColumnHelper<IProducto>();

let optionsParametros: Array<any> = [];
interface IProductoProps {
  cbAreaResponsable?: Array<IAreaResponsable>;
  items?: Array<any>;
}
const Producto = ({ cbAreaResponsable, items }: IProductoProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboAr, setComboAr] = useState<Array<IAreaResponsable>>(cbAreaResponsable || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentSearch = () => {
    return (
      <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
        <i className="bi bi-search"></i>
      </a>
    );
  };

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let paramsMax = { PAGINA: 1, PAGINADO: ROW_COUNT_MAX, ORDENADOPOR: "ID", ORIENTACION: "ASC", ACTIVO: true };
    let paramsParamsActive = cParamsActiveOrderTitle;

    optionsParametros = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PARAMETROS}/getall`, { Authorization: `Bearer ${token}` }, paramsMax)).result.data;

    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, paramsParamsActive)).result
      .data;
    setComboAr(combo);

    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<IProducto>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.TIPO_PROCESO = filter.ID_TIPO_PROCESO?.toString();
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IProducto, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    value.ID_TIPO_PROCESO = value.ID_TIPO_PROCESO || 1;
    postAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID !== undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let columnsDef = [
    columnHelperProducto.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<IProducto, number>) => info.getValue(),
      header: () => component("ID"),
      tipo: ITipo_Campo.key,
      title: "ID",
    } as any),
    columnHelperProducto.accessor((row) => row.TITULO, {
      id: "TITULO",
      cell: (info: CellContext<IProducto, number>) => componentValue(info.getValue()),
      header: () => component("Producto"),
      tipo: ITipo_Campo.text,
      title: "Título",
      required: true,
    } as any),
    columnHelperProducto.accessor((row) => row.TIPO_PROCESO, {
      id: "ID_TIPO_PROCESO",
      cell: (info: CellContext<IProducto, number>) => componentValue(info.getValue()),
      header: () => component("Tipo Proceso"),
      tipo: ITipo_Campo.combo,
      title: "Tipo Proceso",
      required: true,
    } as any),
    columnHelperProducto.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IProducto, boolean>) => componentValue(info.getValue() === true ? "Sí" : "No"),
      header: () => component("Activo"),
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperProducto.accessor((row) => row.PARAMETROS_EVALUAR, {
      id: "PARAMETROS_EVALUAR",
      cell: (info: CellContext<IProducto, boolean>) => componentValue(info.getValue()),
      header: () => component("Parámetros a evaluar"),
      tipo: ITipo_Campo.multicheck,
      title: "Parámetros a evaluar",
      options: optionsParametros,
      hide: true,
    } as any),
    columnHelperProducto.display({
      id: "editar",
      header: () => component("Editar"),
      cell: (props) => componentSearch(),
    }),
  ];
  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            { ID: "", ACTIVO: true, ORDENADOPOR: "", ORIENTACION: "", PAGINA: 1, PAGINADO: 10, TITULO: "", ID_TIPO_PROCESO: 1, TIPO_PROCESO: "" },
            {}
          );
          paging(1);
          filter(false as unknown as Partial<IProducto>, false, 1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_TIPO_PROCESO",
            value: comboAr.map((ar) => {
              return { text: ar.TITULO, value: ar.ID };
            }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"Producto"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Productos"
        columnsDef={columnsDef}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Producto;
